import { ImageLinkTargets, ImageModel } from "@courses-pm2/api/src/ts/models";
import { Engine, resolveMediaPath } from "@courses-pm2/api/src/ts/utils";

import { parseCaptionedContentElement } from "@courses-pm2/api/src/ts/parser/parseCaptionedContentElement";

/**
 * Helper that parses <Image /> elements in the response from the pm2 backend.
 */
export async function parseImage({ node, portalId, engine }: {
    node: Element;
    portalId: string;
    engine?: Engine;
}): Promise<ImageModel> {
    // Announce that a model has been identified if possible
    if (engine) {
        engine.announce(ImageModel);
    }

    return new ImageModel({
        engine,
        portalId,

        // Extract basic configurations of the image
        externalLink: node.getAttribute("externalLink") || undefined,
        internalLink: node.getAttribute("internalLink") || undefined,
        src: resolveMediaPath(node.getAttribute("src") || ""),
        width: parseInt(node.getAttribute("width") || "", 10) || undefined,
        height: parseInt(node.getAttribute("height") || "", 10) || undefined,

        // Determine target when opening internal links
        target: parseImageLinkTarget(node.getAttribute("target")),

        // Push basic configurations for a captioned content element
        ...parseCaptionedContentElement(node),
    });
}

/**
 * Helper that'll transform the target="..." prop to our internal target
 * enumeration, so we can safely handle it within the component.
 */
function parseImageLinkTarget(target: string | null): ImageLinkTargets {
    switch (target) {
        case "new-window":
            return ImageLinkTargets.NEW_WINDOW;

        case "lightbox":
            return ImageLinkTargets.LIGHTBOX;

        default:
            return ImageLinkTargets.SAME_WINDOW;
    }
}
